import React from "react";
import { Box, Typography, Container, Button, Grid  } from "@mui/material";
import Layout from "./../components/Layout/Layout";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';


const Pagenotfound = () => {
  return (
    <Layout>
      
      <Box
      sx={{
        bgcolor: 'background.paper',
        py: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Container maxWidth="md">
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={8} textAlign="center">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 4,
              }}
            >
              <SentimentVeryDissatisfiedIcon
                sx={{ fontSize: 80, color: 'primary.main' }}
              />
            </Box>
            <Typography variant="h1" color="text.primary" gutterBottom>
              404
            </Typography>
            <Typography variant="h4" color="text.secondary" gutterBottom>
              Page Not Found
            </Typography>
            <Typography variant="body1" color="text.secondary" mb={4}>
              We’re sorry, the page you have looked for does not exist on our
              website! Maybe go to our home page or try to use a search?
            </Typography>
            <Button
              href="/"
              variant="contained"
              size="large"
              sx={{ borderRadius: '50px', py: 1.5, px: 4 }}
            >
              Go Back To Home
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Box>
    </Layout>
  );
};

export default Pagenotfound;
